import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 12 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 20\" id=\"icon-arrow-left\">\r\n  <path id=\"icon-arrow-left_Path\" d=\"M-11.674,9.22l9.09-8.9A1.121,1.121,0,0,1-1.794,0,1.121,1.121,0,0,1-1,.32l.669.655a1.079,1.079,0,0,1,0,1.547L-7.968,10l7.641,7.482A1.075,1.075,0,0,1,0,18.251a1.076,1.076,0,0,1-.326.774L-1,19.68a1.122,1.122,0,0,1-.79.32,1.121,1.121,0,0,1-.79-.32l-9.1-8.908A1.076,1.076,0,0,1-12,10,1.076,1.076,0,0,1-11.674,9.22Z\" transform=\"translate(12)\" fill=\"#a6291a\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol